import React from "react";

interface DataFieldProps {
  label: string;
  value: number | string;
}

const StatusField: React.FC<DataFieldProps> = ({ label, value }) => {
  return (
    <div className="flex-col justify-center items-center inline-flex">
      <div className="text-[#6d6f7d] text-sm font-medium font-[]">{label}</div>
      <div className="text-[#303139] text-lg font-semibold font-[] items-center flex-row flex gap-1">
        {value ?? "-"}
        {label === "Estado" ? 
        <svg width="16" height="16">
          <circle  cx="8" cy="10" r="6" fill={
              value === "Operativo" ? "#80BF80" : 
              value === "Parcial" ? "#EBCF4D" : 
              value === "En proceso de instalación" ? "#EBCF4D":
              "#FF0000"
            } 
          />
        </svg> : 
        " kWh"}
      </div>
    </div>
  );
};

export default StatusField;